import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { BaseFormComponent } from '../../core/base-form.component';
import { TabRoutes } from '../../shared/modals/tab-routes.enum';
import { FoundationServiceService } from '../../features/services/foundation-service.service';
import { debounceTime, distinctUntilChanged, Subject, switchMap } from 'rxjs';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-handling-permission',
  templateUrl: './handling-permission.component.html',
  styleUrls: ['./handling-permission.component.scss'],
})
export class HandlingPermissionComponent
  extends BaseFormComponent
  implements OnInit, OnDestroy {
  boardPositions: any;
  commercialOffices: any;
  override save(): Promise<void> {
    throw new Error('Method not implemented.');
  }
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  form!: FormGroup;

  identityTypes = [
    /* هتجيبها من API أو static */
  ];
  filePath: any;
  uploadedFileUrl: string = '';

  companies: any[] = [];
  isSearching = false;
  private searchSubject = new Subject<string>();
  freeZones: any[] = [];
  constructor(
    private fb: FormBuilder,
    private service: FoundationServiceService,
    private router: Router
  ) {
    super();
    this.filePath = TabRoutes.Activities;
  }

  override ngOnInit(): void {
    this.loadBoardPositions();
    this.loadCommercialRegistryOffices();
    this.loadFreeZones();
    this.form = this.fb.group({
      establishmentRequestId: [null],

      companyName: ['', Validators.required],

      boardPositionId: [null, Validators.required],

      identifierUrl: ['', Validators.required],
      extractedCompanyCommercialUrl: ['', Validators.required],

      registrationNumber: [''],
      registryOfficeId: [null],

      taxRegistrationNumber: [''],
      isForeign: [false],

      commercialRegistryExtractionDate: [''],

      declarationOne: [false, Validators.requiredTrue],
      declarationTwo: [false, Validators.requiredTrue],
      freeZoneCode: [null, Validators.required]
    });

    this.searchSubject
      .pipe(
        debounceTime(1000), // wait 1 second after last keystroke
        distinctUntilChanged()
      )
      .subscribe((value) => {
        if (value.trim()) {
          this.service.searchCompanies(value).subscribe((res) => {
            this.companies = res?.data || [];
          });
        } else {
          this.companies = [];
        }
      });
  }

  onInputChange(event: any) {
    const value = event.target.value;
    this.searchSubject.next(value);
  }

  override ngOnDestroy(): void {
    this.searchSubject.complete();
  }

  onCompanyChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    const selectedCompany = this.companies[select.selectedIndex];

    if (!selectedCompany) return;

    this.form.patchValue({
      companyName:
        selectedCompany.companyNameAr || selectedCompany.companyNameEn,
      establishmentRequestId: selectedCompany.establishmentRequestId,
    });

    this.companies = [];
  }

  loadBoardPositions(): void {
    this.service.getLookupByType('BOARD_POSITION').subscribe({
      next: (res) => {
        this.boardPositions = res || [];
      },
      error: (err) => console.error('❌ Error fetching board positions:', err),
    });
  }
  loadFreeZones(): void {
    this.service.getLookupByType('FREE_ZONE').subscribe((zones) => {
      this.freeZones = zones;
    });
  }

  loadCommercialRegistryOffices(): void {
    this.service.getLookupByType('REGISTRY_OFFICE').subscribe({
      next: (res) => {
        this.commercialOffices = res || [];
      },
      error: (err) => console.error('❌ Error fetching board positions:', err),
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const payload = {
      boardPositionId: this.form.value.boardPositionId,
      establishmentRequestId: this.form.value.establishmentRequestId,
      identifierUrl: this.form.value.identifierUrl,
      extractedCompanyCommercialUrl:
        this.form.value.extractedCompanyCommercialUrl,
      registrationNumber: this.form.value.registrationNumber,
      registryOfficeId: this.form.value.registryOfficeId,
      taxRegistrationNumber: this.form.value.taxRegistrationNumber,
      isForeign: this.form.value.isForeign,
      commercialRegistryExtractionDate:
        this.form.value.commercialRegistryExtractionDate,
      companyName: this.form.value.companyName,
      freeZoneCode: this.form.value.freeZoneCode
    };

    this.isSubmitDisabled = true;

    this.service.createTransactionAuthority(payload).subscribe({
      next: (res) => {

        const requestNumber =
          res?.data?.requestNumber || res?.data?.establishmentRequestId;
        this.isSubmitDisabled = false;
        console.log('Response:', res);
        if (res?.success) {
          Swal.fire({
            icon: 'success',
            title: 'تم الحفظ بنجاح',
            html: `
              <p>تم حفظ صلاحية التعامل بنجاح</p>
              <p><strong>رقم الطلب:</strong> ${requestNumber}</p>
            `,
            confirmButtonText: 'حسناً',
          }).then(() => {
            // Navigate after clicking OK
            console.log('rooo')
            this.router.navigate(['/ervices/main-services']);
          });

          console.log('✅ Saved successfully', res.data);
          this.form.disable();
        } else {
          Swal.fire({
            icon: 'error',
            title: 'فشل الحفظ',
            text: res?.message || 'حدث خطأ أثناء الحفظ',
            confirmButtonText: 'موافق',
          });
        }
      },
      error: (err) => {
        this.isSubmitDisabled = false;

        Swal.fire({
          icon: 'error',
          title: 'حدث خطأ',
          text: 'تعذر حفظ البيانات، يرجى المحاولة مرة أخرى',
          confirmButtonText: 'موافق',
        });

        console.error('❌ Error saving transaction authority', err);
      },
    });
  }

  onUploadComplete(event: any, controlName: string): void {
    this.form.get(controlName)?.setValue(event.url);
  }

  onFileRemoved(controlName: string): void {
    this.form.get(controlName)?.reset();
  }
}
